import { render, staticRenderFns } from "./leadstagesmall.vue?vue&type=template&id=20a4d8cd"
import script from "./leadstagesmall.vue?vue&type=script&lang=js"
export * from "./leadstagesmall.vue?vue&type=script&lang=js"
import style0 from "./leadstagesmall.vue?vue&type=style&index=0&id=20a4d8cd&prod&scop=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports